export var AssetLevel = /*#__PURE__*/function (AssetLevel) {
  AssetLevel[AssetLevel["Environment"] = 1] = "Environment";
  AssetLevel[AssetLevel["Library"] = 2] = "Library";
  AssetLevel[AssetLevel["Theme"] = 3] = "Theme";
  AssetLevel[AssetLevel["Runtime"] = 4] = "Runtime";
  AssetLevel[AssetLevel["Components"] = 5] = "Components";
  AssetLevel[AssetLevel["App"] = 6] = "App";
  return AssetLevel;
}({});
export var AssetLevels = [AssetLevel.Environment, AssetLevel.Library, AssetLevel.Theme, AssetLevel.Runtime, AssetLevel.Components, AssetLevel.App];
export var AssetType = /*#__PURE__*/function (AssetType) {
  AssetType["JSUrl"] = "jsUrl";
  AssetType["CSSUrl"] = "cssUrl";
  AssetType["CSSText"] = "cssText";
  AssetType["JSText"] = "jsText";
  AssetType["Bundle"] = "bundle";
  return AssetType;
}({});